import { gql } from '@apollo/client'

export const GET_EVENT_BY_ID = gql`
  query GetEventById($eventId: ID!) {
    getEventById(eventId: $eventId) {
      eventId
      tag
      name
      description
      address
      city
      cost
      region
      eventDate
      startTime
      endTime
      quantity
      quantityAvailable
      status
      businessUnit
      multipleDates
      unifiedDates
      image
      imageUrl
      rules
      faq
      addressLink
      redeemLimit
      createdAt
      updatedAt
      redeemStatus
      redeem {
        start
        end
      }
      benefit {
        id
        cost
      }
      availableBrand {
        BOT
        QDB
        BLZ
        EUD
      }
      availableDates {
        eventDate
        quantityAvailable
        redeemLimit
        redeemStatus
      }
      eventDays {
        businessUnit
        endTime
        eventDate
        eventId
        name
        quantity
        quantityAvailable
        redeemLimit
        startTime
        status
      }
    }
  }
`
